export class WorkspaceStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<WorkspaceStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<WorkspaceStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
